
import { defineComponent, onMounted, ref, inject } from "vue"
import clubService from "@/core/services/InstitutionService"
import { errManager, showMessage } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

import AddEdit from "./AddEdit.vue"

export default defineComponent({
    name: "Clubs",
    components: {
        AddEdit
    },
    setup() {
        const loader = ref(false)
        const filter = ref({
            category: '',
            type: ''
        })
        const setting = ref({
            categories: <any>[],
            types: <any>[],
        })
        const rowItem = ref({})
        const textSearch = ref<string>('')
        const listClubs = ref<any>([])

        //Pagination start
        const pageSize = ref(10)
        const currentPage = ref(1)
        const totalItems = ref(0)
        //pagination 

        //get sharing data
        const gblDialog = inject<any>('gblDialog')
        const gblAction = inject<any>('gblAction')

        const getSetting = async () => {
            await clubService.getSetting()
                .then((res) => {
                    setting.value = res.data
                }).catch(({ response }) => {
                    errManager(response, null, 2)
                })
        }

        const getData = async () => {
            loader.value = true
            await clubService.getData({
                search: textSearch.value,
                category: filter.value.category,
                instype: filter.value.type,
                pageSize: pageSize.value,
                currentPage: currentPage.value
            })
                .then((res) => {
                    listClubs.value.length = 0
                    listClubs.value = res.data.list
                    totalItems.value = res.data.total
                    loader.value = false
                }).catch(({
                    response
                }) => {
                    listClubs.value.length = 0
                    loader.value = false
                })
        }

        const handleCurrentChange = (val: number) => {
            currentPage.value = val
            getData()
        }

        const onRegister = () => {
            gblAction.value = 'new';
            gblDialog.value = true
        }

        const onEdit = (row) => {
            rowItem.value = row
            gblAction.value = 'edit';
            gblDialog.value = true
        }

        const onResponse = (data) => {
            gblDialog.value = false
            showMessage(data)
            if (data.status == 'success')
                getData()
        }

        const onDelete = (row) => {
            Swal.fire({
                title: 'Eliminar institución',
                html: `¿Desea eliminar la institución <b>${row.business}</b> de forma permanente?`,
                icon: 'warning',
                showClass: {
                    popup: 'animate__animated animate__fadeInDown'
                },
                hideClass: {
                    popup: 'animate__animated animate__fadeOutUp'
                },
                showCancelButton: true,
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Mantener',
                showLoaderOnConfirm: true,
                preConfirm: () => {
                    return clubService.delete(row.idinstitution)
                        .then((res) => {
                            return res.data
                        }).catch(({ response }) => {
                            Swal.showValidationMessage(
                                `Request failed: ${response}`
                            )
                        })
                },
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        icon: result.value.status,
                        title: result.value.title,
                        html: result.value.message
                    })
                    result.value.status === 'success' && getData();
                }
            })
        }

        onMounted(async () => {
            getSetting()
            getData()
        })

        return {
            loader,
            filter,
            setting,
            textSearch,
            listClubs,
            //page
            pageSize,
            currentPage,
            totalItems,
            handleCurrentChange,
            rowItem,
            //events
            getSetting,
            getData,
            onRegister,
            onEdit,
            onDelete,
            onResponse,

        }

    },
})
